<template>
  <div class="main"  v-redirect-if-no-permission:RESTRICTED_AREA>
    <v-form ref="form" style="max-height: 118px">
      <v-container>
        <div class="title text--primary">
          {{ $t("locationsPage.restrictedAreaEditorTitle") }}
        </div>
        <v-layout>
          <v-flex md2 sm12>
            <v-text-field v-model="data.name" append-icon="edit" :label="$t('locationsPage.name')" :rules="[rules.required]" single-line
              hide-details></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2 sm12>
            <v-text-field v-model="data.from" type="datetime-local" :label="$t('locationsPage.from')"  :rules="[rules.required]"/>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md2 sm12>
            <v-text-field clearable v-model="data.to" type="datetime-local" :label="$t('locationsPage.to')" />
          </v-flex>

          <v-spacer></v-spacer>
        
          <v-spacer></v-spacer>
          <v-flex md1>
            <v-btn color="primary" dark class="mb-2" @click.stop="dialog = true">{{ $t("locationsPage.save") }}</v-btn>
          </v-flex>

          <v-dialog v-model="dialog" max-width="290">
            <v-card>
              <v-card-title class="headline">{{ $t("locationsPage.saveChangesQuestion") }}</v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="primary" flat="flat" @click="dialog = false">
                  {{ $t("locationsPage.cancel") }}
                </v-btn>

                <v-btn color="primary" flat="flat" @click="save"> {{ $t("locationsPage.save") }} </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="diaload" hide-overlay persistent width="300">
            <v-card color="primary" dark>
              <v-card-text>
                {{ $t("locationsPage.savingChanges") }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
    </v-form>
    <div id="map"></div>
  </div>
</template>
<script>
import Mapbox from "mapbox-gl";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import centroid from "@turf/centroid";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import moment from "moment";
import { companyNow } from "@/util/companyTime";

export default {
  name: "RestrictedAreaEditor",
  title() {
    return this.$t("locationsPage.restrictedAreaEditorTitle");
  },

  data() {
    return {
      mode: "add", // or edit
      baseUri: "restricted-area",
      id: null,
      map: null,
      diaload: false,
      loading: false,
      dialog: false,
      drawComponent: null,
      answer: null,
      center: null,
      polygon: null,
      data: {
        name: null,
        from:  companyNow().format("YYYY-MM-DD HH:mm"),
        to:  companyNow().format("YYYY-MM-DD HH:mm")
      },
    };
  },
  mounted() {
    Mapbox.accessToken = this.api.mapBox.accessToken;
    this.center = this.api.mapBox.center;
    if (this.$route.params.id !== undefined) {
      this.mode = "edit";
      this.id = this.$route.params.id;
      this.getData();
    } else {
      this.mode = "add";
      this.loadMap();
    }
  },
  methods: {
  
    loadMap() {
      this.map = new Mapbox.Map(
        Object.assign({ container: "map" }, this.api.mapBox, {
          center: this.center,
        })
      );
      this.drawComponent = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true,
        },
      });

      this.map.addControl(this.drawComponent);
      this.map.on("draw.create", this.updateArea);
      this.map.on("draw.delete", this.updateArea);
      this.map.on("draw.update", this.updateArea);
      //   this.center = this.api.mapBox.center;
      // this.marker = new Mapbox.Marker({ draggable: true });
      // this.marker.setLngLat(this.center);
      // this.marker.addTo(this.map);
    },
    getData() {
      this.axios.get(this.baseUri + `/${this.id}`).then(({ data }) => {
        console.log('data');
       
        console.log(data.data);
        const { name, polygon, from, to } = data.data;
        this.center = centroid(polygon).geometry.coordinates;
        this.polygon = data.data.polygon.coordinates[0];
        this.loadMap();
        this.drawComponent.add(polygon);
        this.data.name = name;
        this.data.from =  moment(from).format("YYYY-MM-DD HH:mm");
        this.data.to =  to? moment(to).format("YYYY-MM-DD HH:mm"): null;
      });
    },
    updateArea(e) {
      if (e.type === "draw.create") {
        this.drawComponent.deleteAll();
        this.drawComponent.add(e.features[0]);
      }
    },
    reset() {
      this.drawComponent.deleteAll();
      this.data.name = null;
      this.data.from = null;
      this.data.to = null;
    },
    save() {
      this.data.from =  moment(this.data.from).format("YYYY-MM-DD HH:mm");
      this.data.to = this.data.to ? moment(this.data.to).format("YYYY-MM-DD HH:mm"):null;
      if (this.mode == "edit") {
       
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("locationsPage.choosePolygon"));
            return;
          }
            this.loading = true;
            this.diaload = true;
            this.dialog = false;

            const polygon = polygons[0].geometry;

            const url =
              this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
            (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
              polygon,
              ...this.data,
            })
              .then(() => {
                window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.saved"), "green");
                this.mode === "add" ? this.reset() : null;
              })
              .catch(() =>
                window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.notSaved"), "red")
              )
              .finally(() => {
                this.loading = false;
                this.diaload = false;
              });
          
        }
      }

      if (this.mode == "add") {
        const polygons = this.drawComponent.getAll().features;
        if (!this.loading && this.$refs.form.validate()) {
          if (polygons.length === 0) {
            alert(this.$t("locationsPage.choosePolygon"));
            return;
          }
          this.loading = true;
          this.diaload = true;
          this.dialog = false;


          const polygon = polygons[0].geometry;

          const url =
            this.mode === "add" ? this.baseUri : this.baseUri + "/" + this.id;
          (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
            polygon,
            ...this.data,
          })
            .then(() => {
              window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.saved"), "green");
              this.mode === "add" ? this.reset() : null;
            })
            .catch(() => window.getApp.$emit("SHOW_TOAST", this.$t("locationsPage.notSaved"), "red"))
            .finally(() => {
              this.loading = false;
              this.diaload = false;
            });
        }
      }
    },
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t("locationsPage.ruleRequired"),
        number: (value) => isFinite(value) || this.$t("locationsPage.ruleNumber"),
      };
    }
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: calc(100vh - 64px - 118px);
}
</style>
